export const TANK_FAMILIES = ["B", "G", "P", "Q"] as const;
export type TankFamily = (typeof TANK_FAMILIES)[number];

export const BREEDER_SEXES = ["male", "female", "unknown"] as const;
export type BreederSex = (typeof BREEDER_SEXES)[number];

export const QUANTITY_PRECISIONS = ["unknown", "estimated", "exact"] as const;
export type QuantityPrecision = (typeof QUANTITY_PRECISIONS)[number];

export type OccupantKind = "breeder" | "pair" | "stock_group";

export function normalizeTankCode(raw: string): string | undefined {
  const compact = raw.trim().toUpperCase().replaceAll(/\s+/g, "");
  const match = /^([BGPQ])(\d{1,3})$/.exec(compact);

  if (!match) {
    return undefined;
  }

  const family = match[1];
  const number = Number(match[2]);

  if (!family || !Number.isInteger(number) || number < 1 || number > 999) {
    return undefined;
  }

  return `${family}${String(number).padStart(3, "0")}`;
}

export interface StockQuantity {
  quantity?: number;
  precision: QuantityPrecision;
}

export function stockQuantityIsValid(value: StockQuantity): boolean {
  if (value.precision === "unknown") {
    return value.quantity === undefined;
  }

  return value.quantity !== undefined && Number.isInteger(value.quantity) && value.quantity >= 0;
}
